/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { McpSiteAssignmentDto } from './mcpSiteAssignmentDto.schema';

export const ListOfMcpSiteAssignmentDto = zod.array(zod.lazy(() => McpSiteAssignmentDto));

export type ListOfMcpSiteAssignmentDto = zod.input<typeof ListOfMcpSiteAssignmentDto>;
export type ListOfMcpSiteAssignmentDtoOutput = zod.output<typeof ListOfMcpSiteAssignmentDto>;
